import "./statuscard.scss"

interface IStatusCard {
    icon: JSX.Element
    type: "info" | "success" | "danger" | "warning"
    status: string
    suffix: string
    title: string
    subTitle: string
    chart: JSX.Element
}

const StatusCard = ({icon, type, status, suffix, title, subTitle, chart}: IStatusCard) => {
    return (
        <div className="Status-Card">
            <div className="Status-Card-Header">
                <div className="Status-Card-Icon-Box" status-type={type}>
                    {icon}
                </div>
                <div className="Status-Card-Status-Box">
                   <span className="Status-Card-Status-Box-Status">
                       {status}
                   </span>
                    <span className="Status-Card-Status-Box-Suffix">
                       {suffix}
                   </span>
                </div>
            </div>
            <div className="Status-Card-Body">
                <div className="Status-Card-Body-Text">
                    <h6 className="Status-Card-Body-Text-Title">
                        {title}
                    </h6>
                    <p className="Status-Card-Body-Text-SubTitle">
                        {subTitle}
                    </p>
                </div>
                <div className="Status-Card-Body-Chart">
                    {chart}
                </div>
            </div>
        </div>
    )
}

export default StatusCard